import Settings from '../../../base/menu/airdome/Settings';

const settings: Settings = {
  categoryName: 'Einstellung',
  current: 'Aktuell'
};

export default settings;
